import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { CAT_FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { categoryOptions } from './configoptions';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';

@Component({
  selector: 'ubs-categories',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent extends BaseComponentConfig implements OnInit {
  /* options:ConfigOptions = {
    name:"",
    title:"Categories Component",
    listForm:new OfbizList( { 
      listType:"grid",
      listFormName:"EditProdCatalogCategories",
      listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
      columnFields:this.getFields("EditProdCatalogCategories",CAT_FORMS),
      fieldFormFields:this.getFields("AddProductCategoryToProdCatalog",CAT_FORMS),
      appContext:"product",
      emptyListMessage:"No categories found. Please add category",
      remoteFormData:{
        formData:{
          formName:"EditProdCatalogCategories",
          formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
          listType:"grid",

        },
        parameters:{"prodCatalogId":"DemoCatalog"}
      },
    }),
    addForm:new OfbizForm({
      local:true,
        formName:"EditCategory",
        formLocation:"component://kwikstore/widget/CategoryForms.xml",
        fields:this.getFields("EditCategory",CAT_FORMS),
        titleDescriptionField:this.getTitleDescriptionField("EditCategory",CAT_FORMS),
      idFieldName:this.getIdFieldName("EditCategory",CAT_FORMS),
    }),
    findForm:new OfbizForm(),
    actions:["list","find","add","edit"],
    settings:[],
    breadCrumbData:{
      displayPrefix:"Product Catalog Categories",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"EditProdCatalogCategories",
        "data":{
          formData:{
            formName:"EditProdCatalogCategories",
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            listType:"grid"
          },
          "endPoint":"",
          "parameters":{"prodCatalogId":""}
        }
      },
      addFormText:"Create Category",
      editFormText:"Update Category"
    },
    relations:[
      {
        title:"Content",
        addContainerTitle:"Add Content",
        listContainerTitle:"Content for this Category",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddCategoryContentAssoc",
        listFormName:"UpdateCategoryContentAssoc",
        listForm:new OfbizList({
          listFormName:"UpdateCategoryContentAssoc",
          listFormLocation:"component://product/widget/catalog/CategoryForms.xml",
          target:this.getTarget("UpdateCategoryContentAssoc",CAT_FORMS),
          columnFields:this.getFields("UpdateCategoryContentAssoc",CAT_FORMS),
          fieldFormFields:this.getFields("UpdateCategoryContentAssoc",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("UpdateCategoryContentAssoc",CAT_FORMS),
          appContext:this.getAppContext("UpdateCategoryContentAssoc",CAT_FORMS),
          emptyListMessage:"No content found for this category. Please add existing content or create new content to add."
        }),
        addForm:new OfbizForm({
          formName:"AddCategoryContentAssoc",
          local:true,
          appContext:this.getAppContext("AddCategoryContentAssoc",CAT_FORMS),
          targets:this.getTargets("AddCategoryContentAssoc",CAT_FORMS),
          formLocation:"component://product/widget/catalog/CategoryForms.xml",
          fields:this.getFields("AddCategoryContentAssoc",CAT_FORMS)
        })
          
      },
      {
        title:"Products",
        addContainerTitle:"Add Product to Category",
        listContainerTitle:"Products In This Category",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddProductCategoryMember",
        listFormName:"EditCategoryProducts",
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"EditCategoryProducts",
          listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
          target:this.getTarget("EditCategoryProducts",CAT_FORMS),
          columnFields:this.getFields("EditCategoryProducts",CAT_FORMS),
          fieldFormFields:this.getFields("EditCategoryProducts",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("EditCategoryProducts",CAT_FORMS),
          appContext:this.getAppContext("EditCategoryProducts",CAT_FORMS),
          emptyListMessage : "No products found.  Please add products",
          remoteFormData:{
            formData:{
              formName:"EditCategoryProducts",
              formLocation:"component://kwikstore/widget/KwikstoreForms.xml",
              listType:"grid"
            }
          }
        }),
        addForm:new OfbizForm({
          formName:"AddProductCategoryMember",
          local:true,
          appContext:this.getAppContext("AddProductCategoryMember",CAT_FORMS),
          targets:this.getTargets("AddProductCategoryMember",CAT_FORMS),
          formLocation:"component://kwikstore/widget/KwikstoreForms.xml",
          fields:this.getFields("AddProductCategoryMember",CAT_FORMS)
        })
      },
      {
        title:"Parties",
        addContainerTitle:"Add Team Member To Category",
        listContainerTitle:"Category Team",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddPartyToCategory",
        listFormName:"ListCategoryParties",
        addForm:new OfbizForm({
          local:true,
          formName:"AddPartyToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:this.getFields("AddPartyToCategory",CAT_FORMS),
          idFieldName:this.getIdFieldName("AddPartyToCategory",CAT_FORMS),
          titleDescriptionField:this.getTitleDescriptionField("AddPartyToCategory",CAT_FORMS),
          targets:this.getTargets("AddPartyToCategory",CAT_FORMS),
          appContext:"product",
        }),
        listForm:new OfbizList({
          listType:"form",
          listFormName:"ListCategoryParties",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          columnFields:this.getFields("ListCategoryParties",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("ListCategoryParties",CAT_FORMS),
          appContext:"product",
          emptyListMessage: "No people associated with this category.  Please add existing person/organisation and create a new person or organisation."
        })
      },
      {
        title:"Parent Categories",
        addContainerTitle:"",
        listContainerTitle:"",
        keyMap:{fieldName:""},
        addFormName:"AddProductCategoryToCategory",
        listFormName:"EditCategoryParentCategories",
        addForm:new OfbizForm({
          local:true,
          formName:"AddProductCategoryToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:this.getFields("AddProductCategoryToCategory",CAT_FORMS),
          idFieldName:"productCategoryId",
          titleDescriptionField:"categoryName",
          targets:this.getTargets("AddProductCategoryToCategory",CAT_FORMS),
          target:this.getTarget("AddProductCategoryToCategory",CAT_FORMS),
          appContext:"product",
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryParentCategories",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          listType:"form",
          columnFields:this.getFields("EditCategoryParentCategories",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("EditCategoryParentCategories",CAT_FORMS),
          appContext:"product",
          emptyListMessage: "No parent category for this category.  Please add existing category as parent. This is not required."
        })

      },
      {
        title:"Child Categories",
        addContainerTitle:"Add Child Category",
        listContainerTitle:"Child Categories",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddChildCategoryToCategory",
        listFormName:"EditCategoryChildCategories",
        addForm:new OfbizForm({
          local:true,
          formName:"AddChildCategoryToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:this.getFields("AddChildCategoryToCategory",CAT_FORMS),
          idFieldName:"productCategoryId",
          titleDescriptionField:"categoryName",
          targets:this.getTargets("AddChildCategoryToCategory",CAT_FORMS),
          target:this.getTarget("AddChildCategoryToCategory",CAT_FORMS),
          appContext:"product",
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryChildCategories",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          listType:"form",
          columnFields:this.getFields("EditCategoryChildCategories",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("EditCategoryChildCategories",CAT_FORMS),
          appContext:"product",
          emptyListMessage:"No child categories for this category. Please add existing category as child or create a new one.  This is not required."
        })
      },
      {
        title:"Product Feature Category Groups",
        addContainerTitle:"Add Product Feature Category Group",
        listContainerTitle:"Product Feature Category Groups",
        addFormName:"AddFeatureGroupToCategory",
        listFormName:"EditCategoryFeatureGroupFeature",
        keyMap:{"fieldName":"productCategoryId"},
        addForm:new OfbizForm({
          formName:"AddFeatureGroupToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:this.getFields("AddFeatureGroupToCategory",CAT_FORMS),
          targets:this.getTargets("AddFeatureGroupToCategory",CAT_FORMS),
          idFieldName:"productCategory",
          titleDescriptionField:"categoryName",
          appContext:"product"
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryFeatureGroupFeature",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          columnFields:this.getFields("EditCategoryFeatureGroupFeature",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("EditCategoryFeatureGroupFeature",CAT_FORMS),
          appContext:"product",
          listType:"form",
          emptyListMessage:"No Product Feature Category Groups for this category.  Please add exiting or create new."
        })
      },
      {
        title:"Product Feature Categories",
        addContainerTitle:"Add Product Feature Category",
        listContainerTitle:"Product Feature Categories",
        addFormName:"AddFeatureCategoryToCategory",
        listFormName:"EditCategoryFeatureCategoryFeature",
        keyMap:{"fieldName":"productCategoryId"},
        addForm:new OfbizForm({
          formName:"AddFeatureCategoryToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:this.getFields("AddFeatureCategoryToCategory",CAT_FORMS),
          appContext:"product",
          idFieldName:"productCategoryId",
          titleDescriptionField:"categoryName",
          targets:this.getTargets("AddFeatureCategoryToCategory",CAT_FORMS)
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryFeatureCategoryFeature",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          columnFields:this.getFields("EditCategoryFeatureCategoryFeature",CAT_FORMS),
          columnFieldTitles:this.getColumnFieldTitles("EditCategoryFeatureCategoryFeature",CAT_FORMS),
          appContext:"product",
          listType:"form",
          emptyListMessage:"No product feature categories for this category. Please add exisiting or create new."
        })
      }
    ],
    outGoingLinks:[
      {
        target:"EditProductRest",
        targetType:"",
        targetWindow:"",
        root:"products",
        segments:[
          {pathElement:"products",parameter:"productCategoryId"},
          {pathElement:"product",parameter:"productId"}
        ],
        parameters:{},
        remoteFormData:{
          formData:{
            formName:"EditProductRest",
            formLocation:"component://kwikstore/widget/ProductForms.xml"
          }
        }
      }
    ]
  } */
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private http:HttpClient) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(categoryOptions);
  }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuItems:NbMenuItem[] = [
      {title:"List Categories",icon:"list-outline",link:"/admin/categories"},
      {title:"New Category",icon:"plus-outline"},
      {title:"Recent Categories",group:true,icon:"grid-outline"}
    ];
    let menuTag = menuAndTitleOptions.menuTag;
    this.getCategories(this.baseUrl).subscribe(resp => {
      let categories:any[] = [];
      let message = resp["successMessage"];
      if(message == "OK"){
        let data = resp["data"];
          let formData = data["formData"];
          let rows:any[] = formData.rows;
          console.log(rows);
          rows.forEach((row:any[]) => {
            let category:any = {};
            row.forEach(field => {
              for(let[k,v] of Object.entries(field)){
                category[k] = v;
              }
            })
            categories.push(category);
          })
          if(categories.length > 0){
            let _menuItems = this.createMenuItems(categories);
            console.log(_menuItems);
            menuItems = menuItems.concat(_menuItems);
          }
          this.menuService.addItems(menuItems,menuTag)
      }
    })
  }

  getCategories(baseUrl:string):Observable<any>{
    let url:string = baseUrl+'widgets/grid/value/EditProdCatalogCategories?location=component://product/widget/catalog/ProdCatalogForms.xml&prodCatalogId=DemoCatalog';
    return this.http.get<any>(url).pipe(
      catchError(this.handleError),
      map(resp => resp))
  }

  createMenuItems(categories:any[]):NbMenuItem[]{
    let menuItems:NbMenuItem[] = [];
    categories.forEach((category,i) => {
      let productCategoryId = category["parameterMap"]["productCategoryId"];
      let menuItem:NbMenuItem = {title:category["productCategoryId"]};
      menuItem.children = [
        {
          title:"Edit Category",
          link:"/admin/categories/category/"+productCategoryId,
          icon:"edit-outline",
          data:{
            event:"edit",
            type:"EditCategory",
            data:{
              formData:{
                formName:"EditCategory",
                formLocation:"component://kwikstore/widget/CategoryForms.xml"
              },
              appContext:"catalog",
              parameters:{productCategoryId:productCategoryId}
            }            
          }
        },
        {
          title:"Content",
          link:"/admin/categories/category/"+productCategoryId+"/content",
          icon:"archive-outline",
          data:{
            event:"relate",
            type:"Content"
          }
        },
        {
          title:"Products",
          link:"/admin/categories/category/"+productCategoryId+"/products",
          icon:"cube-outline",
          data:{
            event:"relate",
            type:"Products"
          }
        },
        {
          title:"Parties",
          link:"/admin/categories/category/"+productCategoryId+"/parties",
          icon:"people-outline",
          data:{
            event:"relate",
            type:"Parties"
          }
        },
        {
          title:"Parent Categories",
          link:"/admin/categories/category/"+productCategoryId+"/parent-categories",
          icon:"arrow-upward-outline",
          data:{
            event:"relate",
            type:"Parent Categories"
          }
        },
        {
          title:"Child Categories",
          link:"/admin/categories/category/"+productCategoryId+"/child-categories",
          icon:"arrow-downward-outline",
          data:{
            event:"relate",
            type:"Child Categories"
          }
        }
      ]
      menuItems.push(menuItem);
      console.log(category);      
    })
    return menuItems
  }

}
